import { useState } from "react";
import appApi from "../../utils/AppApi";
import toast from "react-hot-toast";
import errorHandler from "../../utils/ErrorHandler";
import { useDispatch, useSelector } from "react-redux";
import {
  setShowOtp,
  setResetPassNationalCode,
  setNationalCodeOtp,
  setShowNationalCodeDialog,
} from "../../redux/actions/User";
import { useNavigate } from "react-router";

export default function useForegetPassAcitons() {
  const [nationalCode, setNationalCode] = useState("");
  const [newPass, setNewPass] = useState("");
  const [newPassRep, setNewPassRep] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { nationalCodeOtp, resetPassNationalCode } = useSelector(
    ({ user }) => user
  );

  const navigate = useNavigate();

  const handleChangeNationalCodeInput = (e) => {
    setNationalCode(e.target.value);
    dispatch(setResetPassNationalCode(e.target.value));
  };

  const handleChangeNewPassInput = (e) => {
    setNewPass(e.target.value);
  };

  const handleChangeNewPassRep = (e) => {
    setNewPassRep(e.target.value);
  };

  const handleSendForgetPassWord = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (nationalCode) {
      try {
        await appApi
          .post("/user/forgetPassword", {
            nationalCode: nationalCode,
          })
          .then((res) => {
            if (res.status === 200) {
              dispatch(setShowOtp(true));
              setLoading(false);
            }
          });
      } catch (error) {
        errorHandler(error);
        setNationalCode("");
        setLoading(false);
      }
    }
  };

  const changePassWithOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (newPass && newPassRep) {
      if (newPass === newPassRep) {
        try {
          await appApi
            .post("/user/changePasswordWithOtp", {
              nationalCode: resetPassNationalCode,
              otp: nationalCodeOtp,
              newPassword: newPass,
            })
            .then((res) => {
              if (res.status === 200) {
                setNationalCode("");
                setLoading(false);
                dispatch(setResetPassNationalCode(""));
                dispatch(setShowNationalCodeDialog(true));
                dispatch(setNationalCodeOtp(""));
                toast.success("رمز عبور با موفقیت تغییر یافت");
                navigate("/login", { replace: true });
              }
            });
        } catch (error) {
          errorHandler(error);
          setNationalCode("");
          setLoading(false);
        }
      } else {
        toast.error("رمز عبور و تکرار آن باید یکسان باشد");
      }
    }
  };

  return {
    nationalCode,
    handleChangeNationalCodeInput,
    loading,
    handleSendForgetPassWord,
    newPass,
    handleChangeNewPassInput,
    newPassRep,
    handleChangeNewPassRep,
    changePassWithOtp,
  };
}
